// Страница пользователя:
export const UserPage = () => {
  return (
    <div className="flex justify-center w-full">
      <div className="pt-10 w-2/3">
        <img
          className="w-24 h-24 rounded-full float-left mb-2 mr-4"
          src="https://i.pravatar.cc/300"
          alt="Rounded avatar"
        />
        <div className="content-type mb-3">Author</div>
        <p className="text-slate-500 mb-10">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </div>
    </div>
  );
};
